module.exports = __webpack_public_path__ + "img/bergfestival.11ebf574.png";